import React, { Component } from 'react';
import JobAdvertLayout from './JobAdvertLayout';

class JobAdvertDBA extends Component {
  render() {
    return (
      <div>
        <JobAdvertLayout
          jobtitle="Business Analyst"
          description={
            <div>
              <p>
                Distilled ID is looking for a talented Business Analyst to join our growing
                development team in Edinburgh.
              </p>
            </div>
          }
          headingsectionone={
            <div>
            Your key accountabilities
            </div>
          }
          sectionone={
            <div>
              <ul>
                <li>
                  Consulting with our customers to capture, validate and document their business
                  requirements.
                </li>
                <li>
                  Investigate feasibility of potential new business in coordination with the
                  business development manager role.
                </li>
                <li>
                  Project management and planning of multiple projects simultaneously to ensure
                  customer expectations are set and managed.
                </li>
                <li>
                  Liasing with the technical teams to clearly articulate business requirements.
                </li>
                <li>
                  Proactively identify and help define new features to fill perceived gaps
                  in our offering.
                </li>
              </ul>
            </div>
          }
          headingsectiontwo={
            <div>
            Your key competencies
            </div>
          }
          sectiontwo={
            <div>
              <ul>
                <li>
                  Strong inter-personal skills, including listening, engaging, negotiating
                  and inspiring.
                </li>
                <li>
                  Excellent ability to analyse problems and propose clear and effective
                  solutions.
                </li>
                <li>
                  A good understanding of technology solutions as a service.
                </li>
                <li>
                  Quick and innovative thinker.
                </li>
                <li>
                  Self-starter, able to work without direct supervision.
                </li>
                <li>
                  Highly motivated and resilient.
                </li>
                <li>
                  Commitment our values and behaviours.
                </li>
              </ul>
            </div>
          }
          headingsectionthree={
            <div>
              Nice to have
            </div>
          }
          sectionthree={
            <div>
              <ul>
                <li>
                  Agri-food experience, preferably operational/R&D/production/supply
                  chain in nature.
                </li>
              </ul>
            </div>
          }
          salary={
            <div>
             Starting salary: £40,000
            </div>
          }
        />
      </div >
    );
  }
}

export default JobAdvertDBA;



// WEBPACK FOOTER //
// ./src/components/common/JobAdvertDBA.js